import { IconProps } from "@design-system/types";

export function LinkedinIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5094 8.796V10.493C12.8646 9.95154 13.3544 9.51165 13.9308 9.21644C14.5072 8.92123 15.1504 8.78083 15.7974 8.809C19.2524 8.809 19.9994 10.969 19.9994 13.779V19.5H16.7994V14.428C16.7994 13.218 16.5554 11.662 14.6714 11.662C12.8444 11.662 12.5324 12.979 12.5324 14.338V19.5H9.34238V8.796H12.5094ZM7.19938 6.106C7.19899 6.423 7.10502 6.73284 6.92926 6.99665C6.7535 7.26047 6.50377 7.46653 6.21138 7.589C5.91911 7.71048 5.5973 7.74226 5.28692 7.68029C4.97653 7.61832 4.6916 7.4654 4.46838 7.241C4.24475 7.01646 4.0925 6.73081 4.03077 6.41997C3.96905 6.10913 4.00061 5.78698 4.12149 5.49403C4.24237 5.20108 4.44717 4.95041 4.71013 4.77354C4.97309 4.59667 5.28248 4.5015 5.59938 4.5C5.80997 4.50013 6.01845 4.5418 6.21291 4.62263C6.40736 4.70346 6.58396 4.82186 6.73258 4.97104C6.88121 5.12023 6.99895 5.29726 7.07905 5.49202C7.15915 5.68677 7.20004 5.89542 7.19938 6.106Z"
        fill="white"
      />
      <path d="M7.2 8.80859H4V19.4996H7.2V8.80859Z" fill="white" />
    </svg>
  );
}
